import { useEffect, useRef } from 'react';

const STORAGE_KEY = 'sizesoftx_ventas_reset';

export const useNotifyVentasReset = () => {
    const sendToOtherTabs = (payload) => {
        try {
            const data = JSON.stringify({
                timestamp: Date.now(),
                event: 'ventas-reset',
                payload
            });
            localStorage.setItem(STORAGE_KEY, data);
            setTimeout(() => {
                localStorage.removeItem(STORAGE_KEY);
            }, 100);
        } catch (e) {
            console.error('Error notifying other tabs:', e);
        }
    };

    return sendToOtherTabs;
};

export const useListenVentasReset = (onResetCallback) => {
    const callbackRef = useRef(onResetCallback);
    
    useEffect(() => {
        callbackRef.current = onResetCallback;
    }, [onResetCallback]);

    useEffect(() => {
        const handleStorageChange = (event) => {
            if (event.key === STORAGE_KEY && event.newValue) {
                try {
                    const data = JSON.parse(event.newValue);
                    if (data.event === 'ventas-reset' && callbackRef.current) {
                        callbackRef.current(data.payload);
                    }
                } catch (e) {
                    console.error('Error parsing storage event:', e);
                }
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);
};